import types from '../types';

const initialState = {
  modalProps: {
    open: false,
  },
  value: undefined,
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.reducerTypes.SHOW_MODAL: {
      return {
        ...state,
        modalProps: { ...action.modalProps, open: true },
        value: undefined,
      };
    }

    case types.reducerTypes.HIDE_MODAL: {
      return {
        ...state,
        modalProps: {
          open: false,
        },
        value: undefined,
      };
    }

    case types.reducerTypes.UPDATE_VALUE_MODAL: {
      return {
        ...state,
        value: action.value,
      };
    }
    default:
  }
  return state;
};

export default modalReducer;
